import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { ApiResponseCode, SHARED_IMPORTS } from '@boshared';
import { Capacitor } from '@capacitor/core';
import { ViewWillEnter } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { UserApiService } from 'projects/bo/src/app/core/services/api/user/user-api.service';
import { ChangePasswordRequest } from 'projects/bo/src/app/core/services/api/user/user.model';
import { AccountState } from 'projects/bo/src/app/core/services/states/account.service';
import { BottomNavState } from 'projects/bo/src/app/core/services/states/bottomnav.service';
import { TopnavComponent } from 'projects/bo/src/app/layout/topnav/topnav/topnav.component';
import { BaseFormComponent } from 'projects/bo/src/app/shared/abstracts/base-form-component.abstract';
import { DynamicFormModule } from 'projects/bo/src/app/shared/components/dynamic-form/dynamic-form.module';
import { GlobalService } from 'projects/bo/src/app/shared/services/global-data/global.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.less'],
  imports: [...SHARED_IMPORTS, DynamicFormModule, TopnavComponent]
})
export class ChangePasswordComponent extends BaseFormComponent implements OnInit, ViewWillEnter {
  protected destroyRef = inject(DestroyRef);
  protected globalService = inject(GlobalService);
  protected userApi = inject(UserApiService);
  protected accountState = inject(AccountState);
  protected bottomNavState = inject(BottomNavState);
  protected form = this.fb.group({
    oldPassword: this.fb.control<string | null>(null, [Validators.required]),
    newPassword: this.fb.control<string | null>(null, [Validators.required]),
    confirmPassword: this.fb.control<string | null>(null, [Validators.required, this.confirmationValidator.bind(this)])
  });

  constructor() {
    super();
    addIcons({
      arrowBackOutline
    });
  }

  ngOnInit() {}

  ionViewWillEnter(): void {
    this.bottomNavState.bottomNavSubject.next({ showNavBar: false });
  }

  onSubmit() {
    if (this.form.invalid) return;

    const formData = this.form.getRawValue();
    const model = {
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword
    } as ChangePasswordRequest;

    this.userApi
      .ChangePassword(model)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        if (res?.code == ApiResponseCode.Success) {
          if (this.globalService.isMobileStyle) {
            this.noticeSvc.showSuccess(`common.message.codeMessage.${res.code}`, '', () => {
              if (Capacitor.isNativePlatform()) {
                this.navigateBack();
                return;
              }

              this.router.navigate(['/accountMobile']);
            });
          } else {
            this.noticeSvc.showSuccess(`common.message.codeMessage.${res.code}`, '', () => this.form.reset());
          }
        }
      });
  }

  private confirmationValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.form.controls.newPassword.value) {
      return { confirm: true, error: true };
    }
    return {};
  }
}
